import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { ExportProps } from 'shared/services';
import { Product } from 'shared/types';

export function useProductRevisionExport() {
    const { productService } = useService();
    const mutation = useMutation<void, Error, ExportProps<Product>>(request =>
        productService.exportRevisionProducts(request)
    );
    return mutation;
}
